export default function debug(...args) {
  if (process.env.VUE_APP_WITH_DEBUG) {
    /* eslint-disable-next-line no-console */
    console.log(...args);
  }
}
